<section>
  <h1 class="mat-headline-4">Cookie Policy</h1>
</section>
<div class="content">
  <mat-accordion>
    <div>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <h3 id="what-are-cookies">What are Cookies?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            As is common practice with almost all professional websites, this site uses cookies. Cookies are small text
            files that, if you agree, are placed on your browser or the hard drive of your computer by websites that you
            visit. They are widely used in order to make websites work, or work more efficiently, as well as to provide
            information to the owners of the site.
            <br /><br />
            This page describes what information they gather, how we use it and why we sometimes need to store these
            cookies. We will also share how you can prevent these cookies from being stored however this may downgrade
            or 'break' certain elements of the sites functionality.
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h3>How do we use Cookies?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry
            standard options for disabling cookies without completely disabling the functionality and features they add
            to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or
            not in case they are used to provide a service that you use. Our website uses cookies to distinguish you
            from other users of our website. This helps us to provide you with a good experience when you browse our
            website and also allows us to improve our site. By continuing to browse the site, you are agreeing to our
            use of cookies.
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h3>What Cookies do we use?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            <span class="font-bold">Strictly Necessary Cookies</span>
            <br /><br />
            These are cookies that are required for the operation of our website. By way of example, these may include
            cookies that enable you to login securely onto our website and/or to make a purchase.
            <br /><br />
            <span class="font-bold">Third Party Cookies</span>
            <br /><br />
            We may also use cookies provided by trusted third parties. The following section details which third party
            cookies you might encounter through this site.
            <br /><br />
            <span class="font-bold">Google Analytics</span> is a tracking and analytical platform, considered as the most widespread
            and trusted solution on the web. Google Analytics helps us understand how you use the site and identifies
            ways how we can improve your experience. These cookies may track instances such as the time you spend on our
            website and the pages that you visit.
            <br /><br />
            <span class="font-bold">Affiliate tracking cookies</span> simply allow us to see if our customers have come to the site
            through one of our partner sites so that we can credit them appropriately.
            <br /><br />
            We run adverts and use third-party <span class="font-bold">targeting and advertising</span> cookies via online
            advertising platforms and marketing automation tools that create behavioural advertising cookies. These
            cookies are used to display tailored advertisements on our platform or on those of third parties. They may
            collect a de-identified, non-human readable version of your email address for matching to other data about
            you to improve the relevance of online advertising and may also collect information such as your email
            address, IP address, browser or operating system type.
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h3>Local Storage</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            We also use other different types of storage, such as local storage. This is required for the operation of
            our website. This type of storage enables you to login to secure areas of our website and remember your
            login information via local storage and those that personalise your experience on the site.
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h3>How do I change my cookie settings?</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Most web browsers allow some control of most cookies through the browser settings. To find out more about
            cookies, including how to see what cookies have been set and how to manage and delete them, visit <a
            target="_blank" rel="noreferrer" href="https://www.aboutcookies.com">www.aboutcookies.com</a> or <a target="_blank"
              rel="noreferrer" href="http://www.allaboutcookies.org">www.allaboutcookies.org</a>.
            <br /><br />
            To opt out of being tracked by Google Analytics across all websites visit <a target="_blank" rel="noreferrer"
              href="https://tools.google.com/dlpage/gaoptout">tools.google.com/dlpage/gaoptout</a>
            <br /><br />
            You block cookies by activating the setting on your browser that allows you to refuse the setting of all or
            some cookies. However, if you use your browser settings to block all cookies (including essential cookies)
            you may not be able to access all or parts of our site.
          </p>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <h3>Amendments</h3>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <p>
            Technologies are constantly evolving therefore this policy may be amended and updated to reflect such
            changes. Please visit this page from time to time to keep updated.
          </p>
        </ng-template>
      </mat-expansion-panel>
    </div>
  </mat-accordion>
</div>